import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Globe, ShoppingBag, BookOpen, Heart, Video, MessageCircle, Calendar, Users, Sparkles } from "lucide-react";
import Storefront from "../commerce/Storefront";
import RevenueAssetsPanel from "../commerce/RevenueAssetsPanel";
import Products from "../Products";
import Webinars from "../Webinars";
import { Memberships, Community, Bookings, Customers } from "../commerce/CommerceStubs";
import { SectionHeader } from "./Capture";

const TABS = [
  { id: "hub",         label: "Public Hub",  icon: Globe,         comp: Storefront,         hint: "Your single public surface" },
  { id: "assets",      label: "Offers",      icon: Sparkles,      comp: RevenueAssetsPanel, hint: "All revenue assets · pricing · delivery" },
  { id: "products",    label: "Products",    icon: ShoppingBag,   comp: Products,           hint: "Legacy product list" },
  { id: "courses",     label: "Courses",     icon: BookOpen,      comp: Memberships,        hint: "Structured learning experiences" },
  { id: "memberships", label: "Memberships", icon: Heart,         comp: Memberships,        hint: "Recurring access tiers" },
  { id: "webinars",    label: "Webinars",    icon: Video,         comp: Webinars,           hint: "Live and evergreen sessions" },
  { id: "community",   label: "Community",   icon: MessageCircle, comp: Community,          hint: "Spaces, channels, conversations" },
  { id: "bookings",    label: "Bookings",    icon: Calendar,      comp: Bookings,           hint: "1:1 sessions and group calls" },
  { id: "customers",   label: "Customers",   icon: Users,         comp: Customers,          hint: "Buyers, members, learners" },
];

export default function Experiences() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "assets";
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.comp || RevenueAssetsPanel;
  const meta = TABS.find(t => t.id === tab);

  return (
    <div data-testid="experiences-page">
      <SectionHeader title="Experiences" subtitle="Everything you sell, host, and grow with — in one place" tabs={TABS} active={tab}
        onChange={(id) => { setTab(id); setParams({ tab: id }); }} hint={meta?.hint} />
      <Active />
    </div>
  );
}
